import { Outlet, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { FormControl, InputLabel, MenuItem, OutlinedInput, Pagination, Select } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import TableClusters from '../GestionClusters/TableClusters';
import { useGetAllCenterTypesPaginated } from './useGetAllCenterTypesPaginated';
import { Buscador } from '../../Pedido/Buscador';
import { useContext } from 'react';
import { GestionClusterContext } from '../../../context/GestionClusterContext';
import { handleChangeInputSearch, handleClearInput, handleKeyDown } from '../../../helpers/buscadorHelper';
import { UserContext } from '../../../context/UserProvider';

export default function GestionTienda() {
  const { userRole } = useContext(UserContext);
  const { inputAfter, setInputAfter, setInputValueSearch } = useContext(GestionClusterContext);
  const {
    centerTypesPaginated,
    isLoading: isLoadingCTypes,
    page,
    limit,
    setPage,
    setActiveFilter,
    activeFilter,
  } = useGetAllCenterTypesPaginated();
  const navigate = useNavigate();

  const handlePagePagination = (event, value = 1) => {
    setPage(value);
  };

  const handleActiveFilterChange = (event) => {
    setActiveFilter(event.target.value);
    setPage(1);
  };

  return (
    <>
      <div className="container-master-user">
        <div className="grid-clusters-centers-container">
          <div className="grid-item">
            <h2 style={{ fontWeight: '600' }}>CLUSTERS</h2>
          </div>
          <div className="grid-item-clusters-centers-search">
            <Buscador
              value={inputAfter}
              width={userRole === 'MasterAdmin' ? '85' : '100'}
              onChange={(e) => handleChangeInputSearch(e, setInputAfter)}
              onKeyDown={(e) => handleKeyDown(e, setInputValueSearch)}
              onClear={() => handleClearInput(setInputValueSearch, setInputAfter)}
            />
            {userRole === 'MasterAdmin' && (
              <Button
                variant="contained"
                color="error"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => navigate('add-clusters')}
                aria-label="add"
                style={{
                  height: '2.5rem',
                }}
              >
                Crear Cluster
              </Button>
            )}
          </div>
        </div>

        <div className="grid-clusters-centers-container">
          <div className="options options-filter">
            <h4 style={{ fontWeight: 'bold' }}>Filtros</h4>
            <FormControl sx={{ maxWidth: 300, marginBottom: 2 }}>
              <InputLabel htmlFor="activeFilter">Filtrar por Activo</InputLabel>
              <Select
                id="activeFilter"
                value={activeFilter}
                onChange={handleActiveFilterChange}
                input={<OutlinedInput label="Filtrar por Activo" />}
              >
                <MenuItem value="all">
                  <em>Todos</em>
                </MenuItem>
                <MenuItem value={true}>Activo</MenuItem>
                <MenuItem value={false}>No Activo</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className="grid-item">
            {!isLoadingCTypes ? (
              <div className="core">
                <TableClusters centers={centerTypesPaginated?.data} />
              </div>
            ) : (
              <div className="custom-loader"></div>
            )}
            {/* </div> */}
          </div>
        </div>

        {centerTypesPaginated?.data?.length > 0 && (
          <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
            <Pagination
              showFirstButton
              showLastButton
              page={page}
              onChange={handlePagePagination}
              count={Math.ceil(centerTypesPaginated?.pagination?.totalItems / limit)}
              color="error"
              variant="outlined"
              size="large"
              sx={{ margin: '2rem' }}
            />
          </div>
        )}
      </div>
      <Outlet></Outlet>
    </>
  );
}
